export default {
  useColorSchemeMediaQuery: false,
  useLocalStorage: false,
  breakpoints: ['40em', '52em', '64em'],
  colors: {
    // background: '#fafafa', // from https://mdigi.tools/color-shades/#5e5555 set to 25 levels
    background: '#FFF',
    white: '#FFF',
    black: '#000',
    link: '#4B2E83', // '#0088dd',
    text: '#333',
    primary: '#4B2E83', // purple
    secondary: '#B7A57A', // gold
    highlight: '#FF815E',
    // palettes generated using https://mycolor.space/?hex=%234B2E83&sub=1
    // and https://maketintsandshades.com/#4B2E83
    blue: {
      2: '#0093BF',
      5: '#0075BB',
      8: '#0055A7',
    },

    purple: {
      1: '#dbd5e6',
      2: '#9382b5',
      3: '#816da8',
      5: '#9975D2',
      7: '#5d438f',
      8: '#4B2E83', // primary
      9: '#3c2569',
    },
    // from UW website palette
    gold: {
      0: '#f8f7f2',
      1: '#f4f1e9',
      2: '#e8e3d3',
      8: '#B7A57A', // secondary
      9: '#85754d',
    },
    // generated from desaturated primary using https://mdigi.tools/color-shades/#5e5555
    grey: {
      0: '#f3f2f2',
      1: '#dbd7d7',
      2: '#c2bcbc',
      3: '#aaa1a1',
      4: '#928686',
      5: '#796d6d',
      6: '#5e5555',
      7: '#433d3d',
      8: '#282424',
      9: '#0d0c0c',
    },
  },
  fonts: {
    body: '"Open Sans",Helvetica,Arial,sans-serif',
    heading: '"Encode Sans",Helvetica,Arial,sans-serif',
  },
  fontSizes: [12, 14, 16, 18, 24, 32, 48, 64, 72, 112],
  fontWeights: {
    body: 400,
    heading: 700,
    bold: 700,
  },
  lineHeights: {
    body: 1.4,
    heading: 1.2,
  },
  layout: {
    container: {
      px: '1rem',
      pt: '1rem',
      pb: '2rem',
      bg: '#FFF',
      // borderLeftWidth: [0, 0, 0, '1px'],
      // borderLeftStyle: 'solid',
      // borderLeftColor: 'grey.0',
      // borderRightWidth: [0, 0, 0, '1px'],
      // borderRightStyle: 'solid',
      // borderRightColor: 'grey.1',
      // '@media print': {
      //   px: 0,
      //   borderLeft: 'none',
      //   borderRight: 'none',
      // },
    },
  },
  sizes: {
    container: '960px',
  },
  text: {
    default: {
      display: 'block', // fix for theme-ui v6 (div => span)
    },
    help: {
      display: 'block',
      color: 'grey.7',
      fontSize: 1,
    },
    paragraph: {
      fontSize: [2, 3],
      large: {
        fontSize: '1.25rem',
      },
    },
    heading: {
      color: 'primary',
      fontFamily: 'heading',
      fontWeight: 700,
      textTransform: 'uppercase',
      section: {
        fontSize: ['1.5rem', '2rem'],
        mb: '1.5rem',
      },
    },
  },
  buttons: {
    primary: {
      cursor: 'pointer',
      color: '#FFF',
      bg: 'primary',
      '&:hover': {
        bg: 'purple.7',
      },
      '& a': {
        color: '#FFF',
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'none',
        },
      },
    },
    disabled: {
      cursor: 'not-allowed',
      color: '#FFF',
      bg: 'grey.4',
    },
    secondary: {
      cursor: 'pointer',
      color: '#FFF',
      bg: 'grey.6',
      '&:hover': {
        bg: 'grey.5',
      },
    },
    close: {
      fontSize: 2,
      pr: '0.5rem',
      cursor: 'pointer',
      outline: 'none',
      background: 'none',
      color: 'grey.5',
      '&:hover': { color: 'grey.9' },
    },
    'toggle-active': {
      flex: '1 1 auto',
      cursor: 'pointer',
      color: '#FFF',
      bg: 'primary',
      '&:hover': {
        bg: 'primary',
      },
    },
    'toggle-inactive': {
      flex: '1 1 auto',
      cursor: 'pointer',
      color: 'grey.9',
      bg: 'purple.1',
      '&:hover': {
        color: '#FFF',
        bg: 'purple.2',
      },
    },
  },
  boxes: {
    section: {
      '&:not(:first-of-type)': {
        mt: '6rem',
      },
    },
  },
  forms: {
    label: {
      userSelect: 'none',
    },

    checkbox: {
      cursor: 'pointer',
      color: 'grey.5',
      'input:focus ~ &': {
        bg: 'purple.1',
        color: 'primary',
      },
    },
    radio: {
      cursor: 'pointer',
      color: 'grey.5',
      'input:focus ~ &': {
        bg: 'purple.1',
        color: 'primary',
      },
    },
  },
  images: {
    basemap: {
      border: '2px solid #FFF',
      boxShadow: '0 1px 5px rgba(0,0,0,0.65)',
      m: 0,
      width: '64px',
      height: '64px',
      borderRadius: '64px',
      '&:hover': {
        boxShadow: '0 1px 5px rgba(0,0,0,1)',
        borderColor: '#EEE',
      },
    },
    'basemap-active': {
      border: '2px solid',
      borderColor: 'highlight',
      boxShadow: '0 1px 5px rgba(0,0,0,0.65)',
      m: 0,
      width: '64px',
      height: '64px',
      borderRadius: '64px',
      '&:hover': {
        boxShadow: '0 1px 5px rgba(0,0,0,1)',
        borderColor: '#EEE',
      },
    },
  },
  alerts: {
    warning: {
      color: 'text',
      bg: '#dbd2bd',
    },
  },
  styles: {
    root: {
      height: '100vh',
      overflowX: 'hidden',
      overflowY: 'hidden',
      margin: 0,
      body: {
        margin: 0,
        height: '100%',
        width: '100%',
        position: 'relative',
        zIndex: 0,
        bg: 'background',
      },
      '#___gatsby': {
        height: '100%',
      },
      '#___gatsby > *': {
        height: '100%',
      },
      fontFamily: 'body',
      fontWeight: 'body',
      lineHeight: 'body',
      h1: {
        variant: 'text.heading',
        fontSize: [5, 6],

        fontWeight: '900 !important',
      },
      h2: {
        variant: 'text.heading',
        fontSize: [4, 5],
        wordSpacing: '0.1rem',
      },
      h3: {
        variant: 'text.heading',
        fontSize: [3, 4],
      },
      h4: {
        variant: 'text.heading',
        fontSize: [2, 3],
      },
      'a, .pseudolink': {
        color: 'link',
        cursor: 'pointer',
        fontWeight: 600,
      },
      ul: {
        pl: '1.25em',
        'li + li': {
          mt: '0.5em',
        },
      },
      figure: {
        margin: 0,
      },
      figcaption: {
        fontWeight: 'bold',
        textAlign: 'center',
        fontSize: [0, 1],
      },

      'section.expandable h3': {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '0.5rem',
        py: '0.25rem',
        px: '0.25rem',
        mt: 0,
        ml: '-0.25rem',
        lineHeight: 1.2,
        bg: 'grey.0',
        borderBottom: '1px solid',
        borderBottomColor: 'gold.8',
        '&:hover': {
          bg: 'grey.0',
        },
        fontFamily: 'body',
        textTransform: 'unset',
        color: 'text',
        fontSize: 3,
      },
      'section.expandable.closed h3': {
        borderTopColor: 'transparent',
        bg: 'background',
        fontWeight: 'normal',
      },

      'section.expandable:not(.closed) + section.expandable': {
        mt: '2rem',
      },

      'section.expandable h3, section.expandable .toggle': {
        cursor: 'pointer',
        position: 'relative',
        '&:hover .arrow': {
          bg: 'gold.9',
        },
        zIndex: 1,
      },
      'section.expandable h3 .arrow, section.expandable .arrow': {
        // default is open state
        width: '1em',
        height: '1em',
        bg: 'gold.9',
        position: 'relative',
        overflow: 'hidden',
        transition: 'background-color 0.5s ease',
        pointerEvents: 'none',
        '&::after': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          width: '0.5em',
          height: '0.5em',
          borderStyle: 'solid',
          borderWidth: '0 1px 1px 0',
          borderColor: '#FFF',
          transform: 'translate(5px, 2px) rotate(45deg)',
          transition: 'transform .5s ease',
          transformOrigin: 'center',
        },
      },

      'section.expandable.closed h3 .arrow, section.expandable.closed .arrow': {
        bg: 'primary',
        '&::after': {
          transform: 'translate(2px, 5px) rotate(-45deg)',
        },
      },
      'section.expandable.closed h3 + .content, section.expandable.closed .toggle + .content':
        {
          display: 'none',
        },
      '.html-content': {
        h2: {
          mt: '3rem',
          mb: '0.5rem',
        },
        h3: {
          mb: 0,
        },

        h4: {
          mb: 0,
        },
        'h4 + ul': {
          mt: '0.25rem',
        },
        p: {
          fontSize: 2,
          wordWrap: 'break-word',
        },
        ul: {
          fontSize: 2,
          wordWrap: 'break-word',
        },
        a: {
          fontSize: 2,
        },
      },

      '@media print': {
        '@page': {
          size: 'Letter portrait',
          margin: '0.75in 0.25in 0.5in 0.25in',
          // '@top-left': { content: '""' },
          '@top-center': {
            color: 'grey.7',
            fontSize: '10pt',
            // for whatever reason, this does not show properly unless we set a standard font
            fontFamily: 'sans-serif',
            fontStyle: 'italic',
          },
          '@bottom-left': {
            fontSize: '10pt',
            content:
              '"University of Washington | Center for Health and the Global Environment | Community Heat Resilience Tool"',
          },
          '@bottom-right': {
            content: 'counter(page)',
            fontSize: '10pt',
          },
        },

        '@page:first': {
          marginTop: 0,
          '@top-left': {
            content: '""',
          },
        },
        body: {
          margin: 0,
          background: '#FFF',
          printColorAdjust: 'exact !important',
          colorAdjust: 'exact !important',
          height: 'auto',
        },
        h1: {
          margin: '0 0 6pt 0',
        },
        '#PageRoot': {
          height: 'auto',
        },
        '#PageContainer': {
          height: 'auto',
          overflow: 'hidden',
          '& > div': {
            height: 'auto',
          },
        },
        '.no-print': {
          display: 'none',
        },
        '.print-only': {
          display: 'block',
        },
        'section, table, .no-break': {
          breakInside: 'avoid',
          pageBreakInside: 'avoid',
        },
        '.break-before': {
          pageBreakBefore: 'always',
          breakBefore: 'always',
        },
        '.break-after': {
          pageBreakAfter: 'always',
          breakAfter: 'always',
        },
      },
      '@media screen': {
        '.print-only': {
          display: 'none',
        },
      },
    },
    hr: {
      borderBottom: '2px solid',
      borderBottomColor: 'secondary',
      my: '2rem',
    },
    progress: {
      color: 'primary',
      bg: 'grey.1',
      height: '1rem',
      percent: {
        color: 'primary',
        bg: 'grey.2',
        height: '0.75rem',
      },
    },
  },
}
